import React from "react";
import { RCCButton, RCCHookToast, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import ListActions from "src/pages/Actions/Panel/components/ListActions";
import { IListActions } from "src/pages/Actions/Panel/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";

const DashboardListMyActionsActions: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();

	const warningMessage = () => {
		addToast({
			color: "yellow",
			description: translate("Acesse o painel de ações para alterar as ações"),
			title: translate("Atenção")
		});
	};

	const {data , loading} = useEffectFetchData<IListActions[]> (
		"DashboardActions/ListMyActions"
	);
	
	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Lista Minhas Ações Recentes")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/actions/panel/?myActions=true">
					<RCCTooltip
						text={translate("Painel de ações")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="actions"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/actions/matrix">
					<RCCTooltip
						text={translate("Matriz de ações")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "table",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>
			
			<DefaultBody>
				{data && (
					<ListActions 
						data={data}
						openModalAttachments={warningMessage}
						openModalCancelConfirm={warningMessage}
						openModalComments={warningMessage}
						openModalEfficiency={warningMessage}
						openModalPostPonementConfirm={warningMessage}
						openModalSubactions={warningMessage}
						openModalChangeProgress={warningMessage}
						openModalShowPostponements={warningMessage}
						options={() => <> </>}
						layout="table"
					/>
				)}
			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardListMyActionsActions;
